import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Globe } from 'lucide-react';
export function Navbar() {
  const {
    language,
    toggleLanguage
  } = useLanguage();
  return <nav className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-gray-100 shadow-sm" data-id="element-89">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="flex justify-between items-center h-16" data-id="element-91">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2" data-id="element-92">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-lg shadow-sm" data-id="element-93">
              CV
            </div>
            <span className="font-bold text-xl text-gray-900 tracking-tight" data-id="element-94">
              CV Go App
            </span>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-4" data-id="element-95">
            <button onClick={toggleLanguage} className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium transition-colors" aria-label={language === 'en' ? 'Switch to Spanish' : 'Cambiar a Inglés'} data-id="element-96">
              <Globe className="w-4 h-4" data-id="element-97" />
              <span data-id="element-98">{language === 'en' ? 'ES' : 'EN'}</span>
            </button>

            <a href="#pricing" className="hidden sm:inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 shadow-sm transition-all" data-id="element-99">
              {language === 'en' ? 'Get Started' : 'Empezar'}
            </a>
          </div>
        </div>
      </div>
    </nav>;
}